import { render, staticRenderFns } from "./bisnesraha.vue?vue&type=template&id=43800683&"
import script from "./bisnesraha.vue?vue&type=script&lang=js&"
export * from "./bisnesraha.vue?vue&type=script&lang=js&"
import style0 from "./bisnesraha.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports